import type { AlchemyActionType } from "replo-runtime/shared/enums";

import * as React from "react";

import Input from "@v1/components/common/designSystem/Input";
import SwitchWithDescription from "@v1/components/designSystem/switch/SwitchWithDescription";
import { DynamicDataSelector } from "@v1/components/editor/page/DynamicDataSelector";
import DynamicDataValueIndicator from "@v1/components/editor/page/element-editor/components/extras/DynamicDataValueIndicator";
import { isDynamicDataValue } from "replo-runtime/shared/utils/dynamic-data";

import DynamicDataButton from "./DynamicDataButton";

type LinkData = { url?: string; openNewTab?: boolean };

type LinkEditorProps = {
  data?: LinkData | string;
  onChange(data: LinkData | string): void;
  placeholder?: string;
  type?: AlchemyActionType;
  allowsDynamicData?: boolean;
};

const LinkEditor: React.FC<React.PropsWithChildren<LinkEditorProps>> = ({
  data,
  onChange,
  placeholder,
  type,
  allowsDynamicData = false,
}) => {
  const isDataAString = typeof data === "string";
  const isRedirectUrlLike = type === "redirect";

  const urlValue = isDataAString ? data : data?.url;
  return (
    <>
      <div className="flex flex-row gap-2">
        {urlValue && isDynamicDataValue(urlValue) && (
          <DynamicDataSelector
            targetType="text/url"
            onChange={(value) => onChange({ url: value as string })}
            trigger={
              <DynamicDataValueIndicator
                type="text"
                templateValue={urlValue}
                onRemove={() => onChange({ url: undefined })}
              />
            }
          />
        )}
        {!isDynamicDataValue(urlValue) && (
          <>
            <Input
              id="link-editor-input"
              autoFocus={true}
              size="sm"
              value={urlValue}
              placeholder={placeholder}
              onChange={(e) => {
                const val = e?.target?.value ?? "";
                onChange(isDataAString ? val : { url: val });
              }}
              layoutClassName="w-full"
            />
            {allowsDynamicData && (
              <DynamicDataSelector
                targetType="text/url"
                onChange={(value) => onChange({ url: value as string })}
                trigger={<DynamicDataButton />}
                side="bottom"
              />
            )}
          </>
        )}
      </div>
      {!isDataAString && isRedirectUrlLike && (
        <SwitchWithDescription
          size="sm"
          isOn={data?.openNewTab ?? false}
          onChange={(checked) => {
            onChange({ openNewTab: checked });
          }}
          label="Open new tab"
          layoutClassName="mt-2"
        />
      )}
    </>
  );
};

export default LinkEditor;
